import BaseComponent from "../../../../lib/components/BaseComponent";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";

import CM from "../../../model/system/CM";
import PropType from "prop-types";
import React from "react";
import {toast} from "react-toastify";
import Close from "../../../../lib/model/service/oauth/dto/Close";
import shortid from "shortid";
import ButtonTab from "../../../../lib/components/tabbar/ButtonTab";
import HelpWindow from "../help/HelpWindow";
import T from "../../../model/system/text_translations/Translator";
import {Avatar, List} from "@mui/material";
import Button from "../buttons/Button";
import {Help, Logout} from "@mui/icons-material";

class SideBar extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      menuElements: []
    };
  }

  addMenu(menu) {
    this.state.menuElements.push(menu);
  }

  clearMenu() {
    this.state.menuElements = [];
  }

  refreshMenu() {
    this.clearMenu();
    this.setState(this.state);
  }

  onSignOutClick(e) {
    let key = CM.get().getSessionValue('oauth_token');
    CM.get().doJsonAjax(CM.get().getServiceUrl('oauth'), new Close(key), function(response) {
      if (response.success) {
        toast.success('Sie wurden ausgeloggt.');
        CM.get().logout();
      } else {
        toast.error('Leider ist etwas schief gelaufen, Sie konnten nicht ausgeloggt werden.');
      }
    });
  }

  render() {
    let menuElements = React.Children.map(this.state.menuElements, (menuElement) => {
      return React.cloneElement(menuElement, {key: shortid()});
    });

    return (<VerticalLayout className='py-5 items-center px-3 gap-y-4 h-full text-cn-color-white'>
      <Avatar sx={{width: 80, height: 80}} src={this.props.avatar}/>
      <VerticalLayout className='gap-4'>
        {menuElements}
      </VerticalLayout>
      <Button
        startIcon={<Logout/>}
        size='large'
        color='error'
        className='w-full'
        onClick={(e) => this.onSignOutClick(e)}>{T.action_logout()}
      </Button>
    </VerticalLayout>);
  }
}

SideBar.propTypes = {
  avatar: PropType.string
}

export default SideBar